import BordUploaderButton from 'components/NudosComponents/BordUploaderButton/BordUploaderButton';
import { ACCEPTED_FILE_EXTENSION } from 'components/NudosComponents/BordUploaderButton/BordUploaderButton.types';
import { useEffect, useState } from 'react';
import { PAYMENTS_PROVIDER } from 'types/orders';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import { useUploadPaymentVoucherForOrder } from './hooks/useUploadPaymentVoucher';
import { useUploadPaymentVoucherForLogisticService } from './hooks/useUploadPaymentVoucherForLogisticService';

import './PaymentVoucherUploader.scss';

interface IPaymentVoucherUploader {
  id?: number;
  billingCountryId?: number;
  voucherUrl?: string;
  disabled?: boolean;
  logisticService?: boolean;
  onUpload?: () => void;
}

export const PaymentVoucherUploader = ({
  id,
  billingCountryId,
  voucherUrl,
  disabled,
  logisticService,
  onUpload
}: IPaymentVoucherUploader) => {
  const paymentVoucherForLogisticService = useUploadPaymentVoucherForLogisticService();
  const paymentVoucherForOrder = useUploadPaymentVoucherForOrder();

  const { isLoading, uploadFile } = logisticService ? paymentVoucherForLogisticService : paymentVoucherForOrder;

  const [url, setUrl] = useState<string>('');

  const upload = async (file: File) => {
    if (!id) return;
    try {
      const fileUrl = await uploadFile(id, file, billingCountryId);

      if (fileUrl) {
        onUpload?.();

        if (typeof fileUrl !== 'string') return;
        setUrl(fileUrl as string);
      }
    } catch (error) {
      displayErrorNotification();
    }
  };

  const downloadFile = () => {
    if (url && isValidLink) {
      window.open(url, '_blank');
    }
  };

  const isValidLink = url?.startsWith('http');
  const paymentThroughPaymentIntegration = url?.includes(PAYMENTS_PROVIDER);
  const defaultFile = url
    ? {
        documentName: 'Comprobante.pdf',
        url: url
      }
    : undefined;

  useEffect(() => {
    if (voucherUrl) {
      setUrl(voucherUrl);
    }
  }, [voucherUrl]);

  return (
    <div className="paymentVoucherUploaderContainer">
      <BordUploaderButton
        title={
          <p className="mb-0">
            <span className="underline">Busca</span> o arrastra el comprobante
          </p>
        }
        defaultFile={defaultFile}
        isFilled={isValidLink}
        customClassName="paymentVoucher"
        customContainerClassName="paymentVoucherUploader"
        customFileNameClass="paymentVoucherUploaderFileName"
        emptyBordUploaderButtonSubtitle="Formatos aceptados: JPG, PDF. Peso máximo: 10mb"
        acceptFileExtension={[ACCEPTED_FILE_EXTENSION.PDF, ACCEPTED_FILE_EXTENSION.JPG]}
        iconsCustomWidth="14px"
        handleChangeFile={upload}
        handleDeleteFile={() => setUrl('')}
        handleDownloadFile={downloadFile}
        disabledBordUploaderButton={isLoading || paymentThroughPaymentIntegration || disabled}
      />
    </div>
  );
};
